import $ from 'jquery';
import Gallery from './gallery';
import scrollTo from '@spinnwerk/scroll-helper/lib/scroll-to';

var Swiper  = {
        init: function() {}
    },
    $swiper = $('.swiper-container');

// only load our form helpers if we have a form on the current page
if ($swiper.length) {
    require.ensure([], () => {
        function getConf(selector) {
            // default swiper settings
            var obj = {
                loop: true,
                preloadImages: false,
                lazyLoading: true,
                lazyLoadingInPrevNext: true,
                lazyLoadingOnTransitionStart: true,
                nextButton: $(selector).closest('.row').nextAll('.swiper-button-next'),
                prevButton: $(selector).closest('.row').nextAll('.swiper-button-prev'),
                closeButton: $(selector).closest('.row').nextAll('.swiper-button-close'),
                paginationClickable: true,
                centeredSlides: true,
                spaceBetween: 12
            };

            // check if the slider isn't limited by a row then adjust our next & prev buttons
            if (!obj.nextButton.length) { obj.nextButton = selector + ' .swiper-button-next'; }
            if (!obj.prevButton.length) { obj.prevButton = selector + ' .swiper-button-prev'; }
            if (!obj.closeButton.length) { obj.closeButton = selector + ' .swiper-button-close'; }

            // swiper specific settings
            switch (selector) {
                case '.swiper--teaser':
                    obj.pagination = selector + ' .swiper-pagination';
                    obj.autoplay = 6000;
                    obj.speed = 1000;
                    break;

                case '.swiper--elements':
                    obj.slidesPerView = 3;
                    obj.breakpoints = {
                        950: { slidesPerView: 2.5 },
                        800: { slidesPerView: 2 },
                        640: { slidesPerView: 1.5 },
                        480: { slidesPerView: 1 }
                    };
                    break;

                case '.swiper--gallery':
                    obj.slidesPerView = 4;
                    obj.loopedSlides = 12;
                    obj.breakpoints = {
                        1024: { slidesPerView: 3 },
                        768: { slidesPerView: 2 },
                        480: { slidesPerView: 1.5 }
                    };
                    obj.onInit = function() {
                        new Gallery();
                    };
                    break;

                case '.swiper--badges':
                    obj.freeMode = true;
                    obj.slidesPerView = 'auto';
                    obj.loopedSlides = 12;
                    obj.autoplay = 2500;
                    obj.autoplayDisableOnInteraction = false;
                    obj.watchSlidesVisibility = true;
                    break;

                case '.swiper--review':
                    obj.slidesPerView = 1;
                    obj.autoplay = 10000;
                    obj.autoplayDisableOnInteraction = false;
                    obj.autoHeight = false;
                    break;
            }

            return obj;
        }

        require(['swiper/dist/js/swiper.jquery.umd.js'], (SwiperPlugin) => {
            Swiper.init = function() {
                // re fetch swiper to always get newest ones too
                $swiper = $('.swiper-container');

                $swiper.each((i, el) => {
                    var conf,
                        $selector = $(el);

                    if (!$selector[0].swiper) {
                        if ($selector.hasClass('swiper--teaser'))   { conf = getConf('.swiper--teaser'); }
                        if ($selector.hasClass('swiper--elements')) { conf = getConf('.swiper--elements'); }
                        if ($selector.hasClass('swiper--gallery'))  { conf = getConf('.swiper--gallery'); }
                        if ($selector.hasClass('swiper--badges'))   { conf = getConf('.swiper--badges'); }
                        if ($selector.hasClass('swiper--review'))   { conf = getConf('.swiper--review'); }

                        new SwiperPlugin(el, conf);
                    }
                });

                // equal height for review swiper items to center them correctly
                let $reviewSwiper = $('.swiper--review'),
                    $reviewSwiperItems = $reviewSwiper.find('.swiper-slide'),
                    reviewSwiperMaxHeight = 0;

                function equalReviewSliderHeight() {
                    $reviewSwiperItems.each(function() {
                        reviewSwiperMaxHeight = Math.max(reviewSwiperMaxHeight, $(this).height());
                    });

                    $reviewSwiper.find('.swiper-slide').css({
                        height: reviewSwiperMaxHeight
                    });
                }

                $(window).resize(function() {
                    equalReviewSliderHeight();
                });
                equalReviewSliderHeight();

                // show overlay when user is inside the heeader swiper
                $('.swiper--teaser').mouseenter(function() {
                    $(this)[0].swiper.stopAutoplay();
                    $(this).find('.rollover').addClass('is-visible');
                }).mouseleave(function() {
                    $(this)[0].swiper.startAutoplay();
                    $(this).find('.rollover').removeClass('is-visible');
                });

                // init the expand arrow
                $('.swiper-button-expand').click(function(event) {
                    event.preventDefault();

                    // destroy swiper instance and add expanded class
                    var $swiper = $(this).siblings('.row').find('.swiper-container'),
                        conf;

                    $swiper[0].swiper.destroy(true, true);
                    $swiper.addClass('swiper--expanded');

                    // hide arrows
                    $(this).hide();
                    $(this).siblings('.swiper-button-next').hide();
                    $(this).siblings('.swiper-button-prev').hide();
                    $(this).siblings('.swiper-button-close').show();

                    $('.swiper-button-close').click(function() {
                        $(this).hide();
                        $(this).siblings('.swiper-button-expand').show();
                        $(this).siblings('.swiper-button-next').show();
                        $(this).siblings('.swiper-button-prev').show();

                        $swiper.removeClass('swiper--expanded');

                        if ($swiper.hasClass('swiper--teaser'))   { conf = getConf('.swiper--teaser'); }
                        if ($swiper.hasClass('swiper--elements')) { conf = getConf('.swiper--elements'); }
                        if ($swiper.hasClass('swiper--gallery'))  { conf = getConf('.swiper--gallery'); }
                        if ($swiper.hasClass('swiper--badges'))   { conf = getConf('.swiper--badges'); }
                        if ($swiper.hasClass('swiper--review'))   { conf = getConf('.swiper--review'); }

                        new SwiperPlugin($swiper, conf);

                        // only scroll if we are on the home page
                        if (!$(this).parents('.page-detail').eq(0)) {
                            scrollTo({top: $(this).prevAll('.row').find('.swiper-container').offset().top - 300});
                        }
                    });
                });
            };

            Swiper.init();
        });
    }, 'swiper');
}

export default Swiper;



// WEBPACK FOOTER //
// ./resources/assets/js/lib/swiper.js